import SeoLanding from "../components/SeoLanding";

export default function GroceryPlannerLanding() {
  return (
    <SeoLanding
      title="Free Grocery Planner — Aisle-sorted shopping lists | NUTRIENT/LAB"
      description="Turn any recipe or meal plan into an aisle-sorted grocery list. Free grocery planner that groups items by store layout so you never make a second loop around the produce section."
      kicker="Free · Aisle-sorted · One-tap export"
      h1={<>The grocery planner<br />that <span className="text-[#C8FF3F]">walks the aisle for you.</span></>}
      toolName="Grocery Planner"
      keywords={[
        "grocery planner", "shopping list app", "grocery list generator", "meal prep grocery list",
        "recipe grocery list", "aisle sorted grocery list", "store layout grocery",
        "weekly grocery planner", "smart shopping list", "meal plan grocery list",
      ]}
      intro="Save a recipe, pick a plan, or scan a link — we compile every ingredient into one deduplicated list, sort by grocery store layout, and hand you the shortest walk through the store."
      deepLink="/grocery"
      deepCta="Open the grocery planner"
      ctaTone="teal"
      benefits={[
        { h: "Aisle-sorted", d: "Every ingredient grouped by produce, dairy, meat, pantry, freezer — no zigzagging." },
        { h: "Deduplicated", d: "Combine multiple recipes and we merge repeated items into one grams-precise line." },
        { h: "One-tap check-off", d: "Cross items off as you shop, and the totals update in real time." },
      ]}
      features={[
        { h: "From any recipe", d: "One-click compile from saved recipes or a live meal plan." },
        { h: "Store layout routes", d: "Follows the standard supermarket flow: produce → deli → meat → dairy → pantry → freezer." },
        { h: "Metric-precise", d: "Quantities computed in grams with pantry-friendly unit rounding." },
        { h: "Multi-plan merge", d: "Add multiple weeks or recipes and see the master list." },
        { h: "Family-friendly", d: "Auto-scale servings by family size and dietary presets." },
        { h: "Allergy-aware", d: "Ingredients matching a person's allergy chips are auto-flagged in-line." },
      ]}
      faqs={[
        { q: "Is the grocery planner free?", a: "Yes — no signup, no card, part of the free NUTRIENT/LAB suite." },
        { q: "How does the aisle sorting work?", a: "Every ingredient is mapped to a store zone (produce, deli, meat, dairy, pantry, freezer, other), and the list is rendered in that walk-through order. Optimized for a typical US/EU supermarket layout." },
        { q: "Can I combine multiple recipes?", a: "Yes. Add any number of saved recipes or a weekly meal plan and the grocery planner will merge and deduplicate identical ingredients." },
        { q: "Does it work with imperial units?", a: "The list stores grams internally for precision, and displays imperial-friendly rounded values (oz, cups, tbsp) where relevant." },
        { q: "Does it flag allergens?", a: "Yes. If a plan person has allergy chips set, matching ingredients are flagged inline so you can swap or skip." },
      ]}
    />
  );
}
